import React from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';
import { usePermissions } from '../context/PermissionContext';

/**
 * L'avviso che i permessi non sono stati caricati.
 *
 * Senza di esso il caricamento fallito è indistinguibile da un account senza permessi:
 * l'utente vedrebbe un'applicazione vuota e nessuna spiegazione. La scelta di negare tutto
 * a chiamata fallita (invece di ricadere sui ruoli del token) è ciò che rende questo
 * avviso necessario.
 */
const PermissionsUnavailableBanner = () => {
  const { status, reload } = usePermissions();

  if (status !== 'error') {
    return null;
  }

  return (
    <Alert
      severity="warning"
      action={<Button color="inherit" size="small" onClick={reload}>Riprova</Button>}
      sx={{ borderRadius: 0 }}
    >
      <AlertTitle>Permessi non disponibili</AlertTitle>
      Non è stato possibile caricare i tuoi permessi: le funzioni sono temporaneamente
      nascoste. Riprova, e se il problema persiste contatta un amministratore.
    </Alert>
  );
};

export default PermissionsUnavailableBanner;
